var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal",
      class: { fade: _vm.transitionDuration > 0 },
      attrs: { tabindex: "-1", role: "dialog" },
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.backdropClicked.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        {
          ref: "dialog",
          staticClass: "modal-dialog",
          class: _vm.modalSizeClass,
          attrs: { role: "document" },
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _vm.header
              ? _c(
                  "div",
                  { staticClass: "modal-header" },
                  [
                    _vm._t("header", function () {
                      return [
                        _vm.dismissBtn
                          ? _c(
                              "button",
                              {
                                staticClass: "close",
                                staticStyle: {
                                  position: "relative",
                                  "z-index": "1060",
                                },
                                attrs: {
                                  type: "button",
                                  "aria-label": "Close",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggle(false)
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { "aria-hidden": "true" } },
                                  [_vm._v("×")]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "h4",
                          { staticClass: "modal-title" },
                          [
                            _vm._t("title", function () {
                              return [_vm._v(_vm._s(_vm.title))]
                            }),
                          ],
                          2
                        ),
                      ]
                    }),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [_vm._t("default")], 2),
            _vm._v(" "),
            _vm.footer
              ? _c(
                  "div",
                  { staticClass: "modal-footer" },
                  [
                    _vm._t("footer", function () {
                      return [
                        _c(
                          "btn",
                          {
                            attrs: { type: _vm.cancelType },
                            on: {
                              click: function ($event) {
                                return _vm.toggle(false, "cancel")
                              },
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.cancelText || _vm.t("uiv.modal.cancel")
                                )
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "btn",
                          {
                            attrs: {
                              type: _vm.okType,
                              "data-action": "auto-focus",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.toggle(false, "ok")
                              },
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.okText || _vm.t("uiv.modal.ok"))
                              ),
                            ]),
                          ]
                        ),
                      ]
                    }),
                  ],
                  2
                )
              : _vm._e(),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", {
        ref: "backdrop",
        staticClass: "modal-backdrop",
        class: { fade: _vm.transitionDuration > 0 },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }